var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDarkMode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3074 5.60357C10.1064 5.73735 8.96752 6.20752 8.02188 6.95997C7.07625 7.71241 6.36227 8.71656 5.96213 9.85685C5.56198 10.9971 5.49192 12.2273 5.76002 13.4056C6.02811 14.584 6.62346 15.6627 7.47755 16.5176C8.33165 17.3726 9.40978 17.969 10.5879 18.2383C11.766 18.5075 12.9962 18.4387 14.1369 18.0397C15.2776 17.6407 16.2825 16.9278 17.0359 15.9829C17.7893 15.038 18.2606 13.8996 18.3956 12.6987C18.4108 12.5643 18.3874 12.4283 18.3283 12.3067C18.2691 12.185 18.1765 12.0827 18.0614 12.0117C17.9463 11.9406 17.8133 11.9038 17.678 11.9055C17.5427 11.9072 17.4107 11.9474 17.2974 12.0213C16.5592 12.4932 15.6821 12.6993 14.811 12.6055C13.9398 12.5117 13.1267 12.1236 12.5059 11.5053C11.8852 10.887 11.4938 10.0755 11.3965 9.20472C11.2991 8.33398 11.5017 7.45608 11.9706 6.71598C12.0477 6.60361 12.0909 6.47152 12.0953 6.33534C12.0996 6.19915 12.0648 6.06458 11.995 5.94755C11.9253 5.83051 11.8234 5.73592 11.7016 5.67496C11.5797 5.614 11.4429 5.58923 11.3074 5.60357Z",
    fill: "#8F8FC6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkMode);
export default __webpack_public_path__ + "static/media/dark_mode.c28b4dc38c34b580d7cd8aa2279fff45.svg";
export { ForwardRef as ReactComponent };